import {Dispatch} from "redux"
import {connect} from "react-redux"

// Models
import {Record} from "../models"
import {RootState} from "../../../models"

// Selectors
import {selectConclusion, selectConclusionEditing, selectUpdatingConclusion, selectParameterEditing} from "../store/selectors"

// Actions
import {updateRecordConclusionAsync, toggleConclusionEditing, toggleParameterEditing} from "../store/actions"

/**
 * @param state
 */
const mapStateToProps = (state: RootState) => ({
    conclusion: selectConclusion(state),
    isConclusionEditing: selectConclusionEditing(state),
    isParameterEditing: selectParameterEditing(state),
    updatingConclusion: selectUpdatingConclusion(state),
});

/**
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
    updateConclusion: (conclusion: Record["conclusion"]) => dispatch(updateRecordConclusionAsync.request(conclusion)),
    toggleConclusionEditing: () => dispatch(toggleConclusionEditing()),
    toggleParameterEditing: () => dispatch(toggleParameterEditing()),
});

/**
 * @param BaseComponent
 */
export default (BaseComponent: any) => connect(mapStateToProps, mapDispatchToProps)(BaseComponent)

export type WithConclusionProps = {
    conclusion: Record["conclusion"]
    updatingConclusion: boolean
    isConclusionEditing: boolean
    toggleConclusionEditing(): void
    isParameterEditing: boolean
    toggleParameterEditing(): void
    updateConclusion(conclusion: Record["conclusion"]): void
}
